import { render } from "./EstudianteSection.vue?vue&type=template&id=9c075fbc&ts=true"
import script from "./EstudianteSection.vue?vue&type=script&lang=ts"
export * from "./EstudianteSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__